module.exports = __webpack_public_path__ + "img/slider_mobil-22.bd4f0796.gif";